import requestService from '../requestService';
import store from '@/store';

export default {
    async listManager(){
        const response = await requestService.get(`/manager?type=${process.env.VUE_APP_TYPE}`,{
            headers: {Authorization : `Bearer ${store.getters.loggedUser.token}`}
        })
        return response?.data
    },
    async getManager(uid){
        const response = await requestService.get(`/manager/${uid}?type=${process.env.VUE_APP_TYPE}`,{
            headers: {Authorization : `Bearer ${store.getters.loggedUser.token}`}
        })
        return response?.data
    },
	async createNewManager(form){
		const response = await requestService.post(`/manager`, form, {
			headers: {Authorization : `Bearer ${store.getters.loggedUser.token}`}
		})
		return response?.data 
	},
    async deleteManager(uid){
        const response = await requestService.delete(`/manager/${uid}/${process.env.VUE_APP_TYPE}`,{
            headers: {Authorization : `Bearer ${store.getters.loggedUser.token}`}
        })
        return response?.data
    },
    async changeManager(uid, form){
        const response = await requestService.post(`/manager/${uid}`, form, {
			headers: {Authorization : `Bearer ${store.getters.loggedUser.token}`}
		})
		return response?.data 
    }
};